import { Injectable } from '@angular/core';

@Injectable()
export class ENV {
  private main: string = "production";

  private development: any =
    {
      API_URL: "https://localhost/ApiFluid/frontend"
    };
  private testing: any =
    {
      API_URL: "https://localhost/ApiFluid/frontend"
    };

  private acceptance: any;
  private production: any=
    {
      API_URL: "https://arquiting.com/ApiFluid/v-0.1.0/frontend"
    };

  constructor() {
  }

  public getEnv () {
    if ( this.main == "development" )
      return this.development;
    if ( this.main == "testing" )
      return this.testing;
    if ( this.main == "acceptance" )
      return this.acceptance;
    if ( this.main == "production" )
      return this.production;
  }
}
